module.exports = __webpack_public_path__ + "img/pandarenh-f-90.a2addbe5.gif";